import {noop} from "lodash";
import {NotificationState, NotificationType} from "./notification-service";

export class NotificationModel {
	title: string;
	content: string;
	type: NotificationType;
	state: NotificationState;
	destroy: Function;
	hideAfterMs: number;

	slideAnimationLength: number;

	get cssClasses(): string {
		switch (this.type) {
			case NotificationType.Success:
				return "notification--success";
			case NotificationType.StickySuccess:
				return "notification--success";
			case NotificationType.Warning:
				return "notification--warning";
			case NotificationType.Error:
				return "notification--error";
			case NotificationType.Info:
				return "notification--info";
			default:
				return "notification--info";
		}
	}

	get styles(): any {
		switch (this.state) {
			case NotificationState.Hidden:
				return {
					"right": "-100%"
				};
			case NotificationState.Show:
				return {
					"right": 0
				};
			default:
				return {};
		}
	}

	constructor(title: string, content: string, type: NotificationType, hideAfterMs: number, destroy: Function = null) {
		this.title = title;
		this.content = content;
		this.state = NotificationState.Hidden;
		this.type = type;
		this.destroy = destroy;
		this.hideAfterMs = hideAfterMs;
		this.slideAnimationLength = 500;
	}

	dismiss() {
		this.state = NotificationState.Hidden;
		setTimeout(() => (this.destroy || noop)(this), this.slideAnimationLength);
	}

	show() {
		setTimeout(() => {
			this.state = NotificationState.Show;

			if (this.type == NotificationType.Success || this.type == NotificationType.Info) {
				setTimeout(this.dismiss.bind(this), this.hideAfterMs);
			}
		});
	}

	onClick(): void {
		this.dismiss();
	}
}
